import { DateFormat } from "../../../../../../constants";
import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form43 = (record: any) => {
  return {
    departmentCode: "3",
    aflType: AFLType.AFLNoSalary,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: "CHI NHÁNH ĐÀ NẴNG",
        },
      },
      {
        type: "title",
        value: {},
      },
      {
        type: "salutation",
        value: ["Tổng Giám Đốc"],
      },
      {
        type: "content",
        value: [
          { type: "eRequestNameAndId", value: { name: record?.eRequestName, id: record?.eEmployeeId } },
          {
            type: "ePositionAndTeam",
            value: {
              position: StringHelper.verticalBarSplit<string[]>(record?.eTitle)[1],
              team: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
            },
          },
          {
            type: "eDoBAndSabre",
            value: {
              dob: record?.eEmployeeBirthday?.format(DateFormat.DD_MM_YYY) || "",
              sabre: record?.eCodeSabre || "",
            },
          },
          {
            type: "eAddress",
            value: record?.eAddress,
          },
          {
            type: "eBusinessTime",
            value: record?.eBusinessTime || "",
          },
          {
            type: "eLongReason",
            value: {
              reason: record?.eReason || "",
              place: record?.eLeavePlace || "",
              range: record?.eVacationPeriods[0],
              title: "nghỉ không lương",
              directorTitle: "Tổng Giám đốc"
            },
          },
          {
            type: "",
            value: `Tôi xin cam đoan chấp hành Quy định, thực hiện các thủ tục có liên quan và chịu trách nhiệm hoàn toàn tính xác thực trước pháp luật. `,
          },
          { type: "", value: "Tôi xin trân trọng cảm ơn !" },
        ],
      },
      {
        type: "dateSection",
        value: ""
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["Ý KIẾN CỦA THỦ TRƯỜNG CHI NHÁNH", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
        textBreak: 1,
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["PHÊ DUYỆT CỦA TỔNG GIÁM ĐỐC", record?.eSteps[3][0].name],
          },
          {
            type: "signature1",
            value: ["Ý KIẾN PHÒNG KHHC", record?.eSteps[2][0].name],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
